import React, { useState, useEffect } from 'react';
import { getUser } from '~src/user';
import { onErrorShowMessage } from '~src/errors';

const ProfilePage = () => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    getUser()
      .then((startup) => {
        if (!mounted) return;
        setUser(startup.user);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        onErrorShowMessage();
      });
    return () => {
      mounted = false;
    };
  }, []);

  const eternoSettingsUrl = `${process.env.ETERNO_URL}/index.php?page=detailOrganizzazione`;
  const eternoLogosUrl = `${process.env.ETERNO_URL}/index.php?page=configurazioni_loghi`;

  const fullName =
    user?.first_name && user?.last_name
      ? `${user.first_name} ${user.last_name}`
      : user?.username || '';

  return (
    <div className="profile-content">
      <section className="profile-hero">
        <div className="profile-hero__headline">
          <h1>Il tuo Profilo</h1>
          <p>Visualizza i dati del tuo account e della tua organizzazione.</p>
        </div>
        <div className="profile-hero__actions">
          <a
            href={eternoSettingsUrl}
            className="g-btn g-btn-primary g-btn-size-md"
            target="_blank"
            rel="noopener noreferrer"
          >
            Impostazioni Azienda
          </a>
          <a
            href={eternoLogosUrl}
            className="g-btn g-btn-outline g-btn-primary g-btn-size-md"
            target="_blank"
            rel="noopener noreferrer"
          >
            Gestione Loghi Azienda
          </a>
        </div>
      </section>

      <section className="profile-details">
        {loading && (
          <div className="profile-details__loading">Caricamento…</div>
        )}

        {!loading && user && (
          <div className="profile-details__grid">
            <div className="profile-details__group">
              <h3>Dati Utente</h3>
              <div className="profile-details__item">
                <span className="profile-details__label">Nome e Cognome</span>
                <span className="profile-details__value">{fullName}</span>
              </div>
              <div className="profile-details__item">
                <span className="profile-details__label">Email</span>
                <span className="profile-details__value">{user.username}</span>
              </div>
              <div className="profile-details__item">
                <span className="profile-details__label">Telefono</span>
                <span className="profile-details__value">
                  {user.telefono || '-'}
                </span>
              </div>
            </div>

            <div className="profile-details__group">
              <h3>Organizzazione</h3>
              <div className="profile-details__item">
                <span className="profile-details__label">Ragione Sociale</span>
                <span className="profile-details__value">
                  {user.org_pointer?.nome || '-'}
                </span>
              </div>
              <div className="profile-details__item">
                <span className="profile-details__label">Partita IVA</span>
                <span className="profile-details__value">
                  {user.org_pointer?.partita_iva || '-'}
                </span>
              </div>
              <div className="profile-details__item">
                <span className="profile-details__label">Sito Web</span>
                <span className="profile-details__value">
                  {user.org_pointer?.sito || '-'}
                </span>
              </div>
              {/* Numero Servizi Annui removed as requested */}
            </div>

            <div className="profile-details__group">
              <h3>Fatturazione</h3>
              <div className="profile-details__item">
                <span className="profile-details__label">PEC</span>
                <span className="profile-details__value">
                  {user.org_pointer?.pec || '-'}
                </span>
              </div>
              <div className="profile-details__item">
                <span className="profile-details__label">
                  Codice Destinatario
                </span>
                <span className="profile-details__value">
                  {user.org_pointer?.codice_destinatario || '-'}
                </span>
              </div>
              <div className="profile-details__item">
                <span className="profile-details__label">Indirizzo</span>
                <span className="profile-details__value">
                  {user.org_pointer?.indirizzo || '-'}
                </span>
              </div>
              <div className="profile-details__item">
                <span className="profile-details__label">Città</span>
                <span className="profile-details__value">
                  {user.org_pointer?.citta || '-'}
                </span>
              </div>
              <div className="profile-details__item">
                <span className="profile-details__label">Provincia</span>
                <span className="profile-details__value">
                  {user.org_pointer?.provincia || '-'}
                </span>
              </div>
              <div className="profile-details__item">
                <span className="profile-details__label">CAP</span>
                <span className="profile-details__value">
                  {user.org_pointer?.cap || '-'}
                </span>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default ProfilePage;
